<div class="modal-wrapper">
  <div class="overlay" *ngIf="blockThisUI">
    <app-spinner></app-spinner>
  </div>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Decision Criteria</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body fixed-body eliminationCategory">
    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table" *ngIf="!blockThisUI">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Column(s)</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let category of displayEliminationCategories.ToArray()">
                <th scope="row">{{ category.displayOrder }}</th>
                <td>{{ category.displayName }}</td>
                <td>
                  <a class="hyperlink" (click)="removeCategory(category)" *ngIf="displayEliminationCategories.Count() !== minCategory">
                    <i class="material-icons" *ngIf="isAllowDeleteOnCriteria(category.displayOrder)"> delete </i>
                  </a>
                </td>
              </tr>
              <tr *ngIf="displayOrder < maxCategory">
                <th scope="row">{{ displayOrder + 1 }}</th>
                <td>
                  <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(category) || null }">
                    <span class="ey-float-label">
                      <input
                        type="text"
                        class="form-control"
                        id="category"
                        name="category"
                        [(ngModel)]="eliminationCategory.displayName"
                        #category="ngModel"
                        pattern="{{ regularExpressionPattern.BasicPattern }}"
                        maxlength="255"
                        required
                        appLabelFloat
                      />
                      <label for="category">Column</label>
                    </span>
                    <span class="help-block" *ngIf="ShowValidationMessage(category) && category.errors.required"> Please enter a column name. </span>
                    <span class="help-block" *ngIf="ShowValidationMessage(category) && category.errors.pattern">
                      special characters are not allowed. (for example: !@#$%^&* etc)
                    </span>
                    <span class="help-block" *ngIf="!ShowValidationMessage(category) && duplicateCategory">
                      Duplicate column names are not allowed.
                    </span>
                  </div>
                </td>
                <td>
                  <a class="hyperlink" (click)="addCategory()">
                    <i class="material-icons"> add_circle </i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()" *ngIf="!blockThisUI" [disabled]="blockButton">Save</button>
  </div>
</div>
